// extracted by mini-css-extract-plugin
export default {"wrapper":"Events2_wrapper__3ETIF","container":"Events2_container__zUxVL","header":"Events2_header__uhXE1","flex":"Events2_flex__h7DRR","btn":"Events2_btn__7VoPn"};